import { useIonViewWillEnter, useIonViewDidLeave } from '@ionic/react'
import React, { FC, useState, useEffect, useRef } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import { activityMobx, memberMobx } from '@mobxStore'
import { CouponItem } from '@cps'
import mktController from 'controllers/mktController'
import ActivityApi from '@api/activity.api'
import { modalLayer, useHistoryNew, getPlatform } from '@utils'
import { keyBy } from '@dt/fe-utils/dist/lodash'
import { BackHeader } from 'pages/mkt/components'
import ActivityDetail from '../components/activityDetail'
import ActivityPage from '../components/activityPage'
import './index.scss'

const { isWeixinMiniProgram } = getPlatform()

interface IProps extends IPage, RouteComponentProps { }

const BindMobile: FC<IProps> = ({ match }) => {
  const { activityId } = match.params as any
  const history = useHistoryNew()
  const [activeInfo, setActiveInfo] = useState<any>({})
  const [couponDetails, setCouponDetails] = useState<any>({})
  const [showLoading, setShowLoading] = useState<boolean>(true)
  const [fixedType, setFixedType] = useState<boolean>(false)
  const { memberInfo } = memberMobx
  const { getActiveDetail } = activityMobx
  const contentRef = useRef<any>(null)
  // Component Event
  const goShare = () => {
    if (memberInfo.mobile) {
      const url = `${location.origin}/activity/bindMobile/${activityId}${location.search}`
      mktController.shareUrl(url)
    } else {
      if (!memberMobx.isLogin) {
        history.push('/login')
      } else {
        if (isWeixinMiniProgram) {
          const query = new URLSearchParams(location.search)
          const appId = query.get('appId')
          const authPhone = query.get('authPhone')
          const jsCode = query.get('jsCode')
          if (appId && authPhone && jsCode) {
            mktController.setWechatMiniappPhoneNumber(appId, authPhone, jsCode)
          } else {
            mktController.jumpBind(history, 'mobile')
          }
        } else {
          mktController.jumpBind(history, 'mobile')
        }
      }
    }
  }
  const getRule = () => {
    modalLayer(ActivityDetail, {
      children: (
        <>
          {activeInfo.extra.copywriting && (
            <div className='detail-des'>
              <div className='title'>{i18n.t('mkt.activity.introduce')}</div>
              <div className='des'>{activeInfo.extra.copywriting}</div>
            </div>
          )}
        </>
      )
    }).then(() => { }, () => { })
  }
  // Data Method
  const getActiveData = () => {
    getActiveDetail(activityId).then((res: any) => {
      setShowLoading(false)
      if (res) {
        setActiveInfo(res)
        transCoupons(res.coupons)
      }
    })
  }
  const transCoupons = (list: any) => {
    ActivityApi.getCouponsList({ couponIds: list.map(item => item.couponId) }).then((coupon: any) => {
      if (coupon?.length > 0) {
        setCouponDetails(keyBy(coupon, 'couponId'))
        getFixedType()
      }
    })
  }
  const getFixedType = () => {
    if (contentRef?.current?.offsetHeight > window.innerHeight) {
      setFixedType(false)
    } else {
      setFixedType(true)
    }
  }
  // Component Effect
  useEffect(() => {
    if (activeInfo?.activityId && memberMobx.memberInfo.type === 'member') {
      let url = `${location.origin}/activity/bindMobile/${activityId}?ct=brand&b=${Config.BRANDID}`
      if (isWeixinMiniProgram) {
        url = `/pages/launch/index?jumpH5Page=${encodeURIComponent(url)}`
      }
      mktController.initShareData({
        url: url,
        title: activeInfo.activityName,
        des: activeInfo.extra?.copywriting,
        img: activeInfo.playbill
      })
    }
  }, [activeInfo, memberMobx.memberInfo])

  useIonViewWillEnter(() => {
    setShowLoading(true)
    getActiveData()
  })
  useIonViewDidLeave(() => {
    setShowLoading(false)
  }, [])
  return (
    <ActivityPage showLoading={showLoading} bgImg={activeInfo?.playbill || ''}>
      {
        activeInfo &&
          <div className='bind-mobile-body' ref={contentRef}>
            <BackHeader>
              {activeInfo?.extra?.copywriting && (
                <div className='active-detail' onClick={getRule}>
                  <span>{i18n.t('mkt.market.marketDetail')}</span>
                  <i className='iconfont icon-chevron-right'></i>
                </div>
              )}
            </BackHeader>
            <div className={fixedType ? 'activity-content-fixed' : 'activity-content'}>
              <div className='coupon-send-main'>
                <div className='share-text'>{memberInfo.mobile ? i18n.t('mkt.activity.bindTip') : i18n.t('mkt.activity.bindGet')}</div>
                <div className='main-block'>
                  {
                    Object.keys(couponDetails).length > 0 && activeInfo.coupons.map((item: any, index: number) => {
                      const hasItem: any = couponDetails[item.couponId]
                      return hasItem && (
                        <div className='coupon-block' key={`${index}-${item.couponId}`}>
                          <CouponItem type='get' couponInfo={hasItem} cnt={item.couponCnt > 1 ? item.couponCnt : ''}></CouponItem>
                        </div>
                      )
                    })
                  }
                </div>
                {
                  activeInfo.isOver
                    ? <div className='coupon-send-btn coupon-send-over'>{i18n.t('mkt.market.eventIsOver')}</div>
                    : <div className='coupon-send-btn' onClick={goShare}>{memberInfo.mobile ? i18n.t('mkt.activity.shareFriend') : i18n.t('mkt.giftCard.toBinding')}</div>
                }
              </div>
            </div>
          </div>
      }
    </ActivityPage>
  )
}
export default observer(BindMobile)
